module.exports = __webpack_public_path__ + "img/SBS_Android.3b6ad0d1.png";